import { getActivityIconUrl } from 'utils/challenge';

export default function useGetActivityIconUrl() {
  return function getActivityIconUrlWithStaticUrl(icon, filetype) {
    return getActivityIconUrl(icon, filetype);
  };
}
